import ApiService from "@Src/services/ApiService";
import { SUBSCRIPTION_API_ROUTES } from "./Subscription.api.constant";

export async function getSubscriptionHistory(params: { page: number; limit: number }) {
    return ApiService.fetchData({
        url: SUBSCRIPTION_API_ROUTES.SUBSCRIPTION_HISTORY,
        method: "get",
        params
    });
}
